// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"41a46f82","774":"66c2f414","858":"6bb84f57"}[chunkId] + ".chunk.js";
};